// @ts-nocheck
import { fulfillmentStatusCode, orderStatus, } from '@/constants';
const removeAllocateCancel = (it) => {
    const orderInfo = it.orderInfo
        .filter(({ statusCode }) => orderStatus.ALLOCATE_CANCEL.code !== statusCode);
    return {
        ...it,
        orderInfo,
    };
};
const getIsSharedWorker = (({ isDistributorUser, userDistributorId, userHubId, workerDistributorId, workerHubId, }) => {
    if (isDistributorUser) {
        return userDistributorId !== workerDistributorId;
    }
    return userHubId !== workerHubId;
});
const addIsSharedWorker = ({ isDistributorUser, userDistributorId, userHubId, }) => (it) => {
    const { group: { distributorId: workerDistributorId, hubId: workerHubId } } = it;
    const isSharedWorker = getIsSharedWorker({
        isDistributorUser,
        userDistributorId,
        userHubId,
        workerDistributorId,
        workerHubId,
    });
    return {
        ...it,
        isSharedWorker,
    };
};
const addAllocateCount = (it) => {
    const allocateCount = it.orderInfo
        .filter(({ statusCode }) => orderStatus[statusCode].group === 'allocate').length;
    return {
        ...it,
        allocateCount,
    };
};
const addPickupCount = (it) => {
    const pickupCount = it.orderInfo
        .filter(({ statusCode }) => orderStatus[statusCode].group === 'pickup').length;
    return {
        ...it,
        pickupCount,
    };
};
export default {
    getterFulfillmentList: (state, getters, rootState, rootGetters) => {
        const isDistributorUser = rootGetters['user/isDistUser'];
        const distributorId = rootGetters['user/distributorId'];
        const hubId = rootGetters['user/hubId'];
        return Object.values(state.fulfillmentTable)
            .map(removeAllocateCancel)
            .map(addIsSharedWorker({
            isDistributorUser,
            userDistributorId: distributorId,
            userHubId: hubId,
        }))
            .map(addAllocateCount)
            .map(addPickupCount);
    },
    getterWorkerList: (state, getters) => getters.getterFulfillmentList
        .reduce((acc, it) => {
        const { user: { code: workerCode, attendCode, name, isGpsOn, }, isSharedWorker, allocateCount, pickupCount, location, } = it;
        const status = isSharedWorker
            ? fulfillmentStatusCode.SHARE
            : fulfillmentStatusCode[attendCode];
        acc.push({
            workerCode,
            status,
            name,
            isSharedWorker,
            allocateCount,
            pickupCount,
            location,
            isGpsOn,
        });
        return acc;
    }, []),
    getterOrderInfoList: (state) => (workerCode) => state.fulfillmentTable[workerCode]?.orderInfo ?? [],
};
